import {Reducers} from './dataEnum';

export const STATUS_SYSTEM_UPDATE = `${Reducers.UPDATE_SYSTEM_STORE}/STATUS_SYSTEM_UPDATE`;
export const INSTALL_SYSTEM_UPDATE = `${Reducers.UPDATE_SYSTEM_STORE}/INSTALL_SYSTEM_UPDATE`;
export const CANCEL_DOWNLOAD_BINARY_UPDATE = `${Reducers.UPDATE_SYSTEM_STORE}/CANCEL_DOWNLOAD_BINARY_UPDATE`;
export const STATUS_DOWNLOAD_BINARY_UPDATE = `${Reducers.UPDATE_SYSTEM_STORE}/STATUS_DOWNLOAD_BINARY_UPDATE`;
export const DOWNLOAD_BINARY_UPDATE = `${Reducers.UPDATE_SYSTEM_STORE}/DOWNLOAD_BINARY_UPDATE`;
export const CHECK_VERSION_SYSTEM = `${Reducers.UPDATE_SYSTEM_STORE}/CHECK_VERSION_SYSTEM`;
export const SYSTEM_UPDATE_PENDING = `${Reducers.UPDATE_SYSTEM_STORE}/SYSTEM_UPDATE_PENDING`;
export const RELEASE_NOTES = `${Reducers.UPDATE_SYSTEM_STORE}/RELEASE_NOTES`;
export const IS_MINIMIZE_UPDATE = `${Reducers.UPDATE_SYSTEM_STORE}/IS_MINIMIZE_UPDATE`;
export const IS_RESTART_LATER = `${Reducers.UPDATE_SYSTEM_STORE}/IS_RESTART_LATER`;
export const SET_UPDATE_SW_STATUS = `${Reducers.UPDATE_SYSTEM_STORE}/SET_UPDATE_SW_STATUS`;
